import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Use sessionStorage instead of localStorage for better security
// sessionStorage is cleared when tab closes, reducing token exposure window
const TOKEN_KEY = 'auth_token';

const getStoredToken = () => {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

let authToken = getStoredToken();

export const setAuthToken = (token) => {
  authToken = token;
  try {
    if (token) {
      sessionStorage.setItem(TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(TOKEN_KEY);
    }
  } catch {
    // Handle cases where storage is not available
  }
};

export const getAuthHeaders = () => ({
  headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
});

// Auth
export const register = (data) => axios.post(`${API}/auth/register`, data);
export const login = (data) => axios.post(`${API}/auth/login`, data);
export const getMe = () => axios.get(`${API}/auth/me`, getAuthHeaders());

// Services
export const getServices = (category) => 
  axios.get(`${API}/services${category ? `?category=${category}` : ''}`);
export const getService = (id) => axios.get(`${API}/services/${id}`);
export const getCategories = () => axios.get(`${API}/categories`);

// Orders
export const createOrder = (data) => axios.post(`${API}/orders`, data, getAuthHeaders());
export const getUserOrders = () => axios.get(`${API}/orders`, getAuthHeaders());
export const getOrder = (id) => axios.get(`${API}/orders/${id}`, getAuthHeaders());

// Payment
export const createPaymentOrder = (data) => 
  axios.post(`${API}/payment/create-order`, data, getAuthHeaders());
export const verifyPayment = (orderId, paymentId) => 
  axios.post(`${API}/payment/verify?order_id=${orderId}&payment_id=${paymentId}`, {}, getAuthHeaders());

// Documents
export const uploadDocument = (formData) => 
  axios.post(`${API}/documents`, formData, {
    ...getAuthHeaders(),
    headers: { ...getAuthHeaders().headers, 'Content-Type': 'multipart/form-data' },
  });
export const getUserDocuments = (orderId) => 
  axios.get(`${API}/documents${orderId ? `?order_id=${orderId}` : ''}`, getAuthHeaders());

// Chat
export const sendChatMessage = (message) => 
  axios.post(`${API}/chat`, { message }, getAuthHeaders());

// Admin
export const checkAdminStatus = () => axios.get(`${API}/admin/check`, getAuthHeaders());
export const getAllTasks = () => axios.get(`${API}/admin/tasks`, getAuthHeaders());
export const getTaskDetail = (taskId) => axios.get(`${API}/admin/tasks/${taskId}`, getAuthHeaders());
export const updateTask = (taskId, data) => 
  axios.patch(`${API}/admin/tasks/${taskId}`, data, getAuthHeaders());
export const updateDocumentStatus = (documentId, status) => 
  axios.patch(`${API}/admin/documents/${documentId}`, { document_id: documentId, status }, getAuthHeaders());
export const downloadDocument = (documentId) => 
  axios.get(`${API}/admin/documents/${documentId}/download`, getAuthHeaders());
export const getAdminStats = () => axios.get(`${API}/admin/stats`, getAuthHeaders());

// Legacy admin (kept for backwards compatibility)
export const getAllOrders = () => axios.get(`${API}/admin/orders`, getAuthHeaders());
export const updateOrderStatus = (orderId, status) => 
  axios.patch(`${API}/admin/orders/${orderId}?status=${status}`, {}, getAuthHeaders());
